module.exports = __webpack_public_path__ + "img/frame (236).164de7fa.jpg";